export default __webpack_public_path__ + "static/media/gg-happy-cropped-more.dc80ce54.png";